// This target is intentionally outside the authenticated-session prefix: an
// auth-expiry cleanup must not discard a document share before login completes.
export const postLoginReturnKey = "vagadmin-public-post-login-return";

export function safePostLoginReturn(value: string | null | undefined) {
  if (!value) return undefined;
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname !== "/app/upload")
      return undefined;
    const share = url.searchParams.get("share");
    if (share && !/^[a-zA-Z0-9-]{1,100}$/.test(share)) return undefined;
    return `${url.pathname}${share ? `?share=${encodeURIComponent(share)}` : ""}`;
  } catch {
    return undefined;
  }
}

export function rememberPostLoginReturn(value: string) {
  const safe = safePostLoginReturn(value);
  if (!safe) return;
  try {
    sessionStorage.setItem(postLoginReturnKey, safe);
  } catch {
    // The ordinary login destination remains available if storage is denied.
  }
}

export function discardPostLoginReturn() {
  try {
    sessionStorage.removeItem(postLoginReturnKey);
  } catch {
    // A denied storage cleanup cannot expose or authorize a tenant operation.
  }
}

export function consumePostLoginReturn() {
  try {
    const value = sessionStorage.getItem(postLoginReturnKey);
    discardPostLoginReturn();
    return safePostLoginReturn(value);
  } catch {
    return undefined;
  }
}
